import types from './types';
import levels from './services';

const get = (params) => {

  function request() { return { type: types.GET_REQUEST } }
  function success(payload) { return { type: types.GET_SUCCESS, payload } }
  function failure(error) { return { type: types.GET_FAILURE, error } }
  
  console.log("_________get all in business")
  return async (dispatch, getState) => {
    console.log('ACTIONS::BUSINESSES::getAll', params);
    dispatch(request());
    const response = await levels.get(params, getState().users.auth.token)
    console.log('ACTIONS::BUSINESSES::getAll::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }

  };  

}

const actions = {
  get,
};

export default actions;